import Vue from 'vue'
import moment from 'moment'
import axios from 'axios'
import defaultSfx from '../audio/notifications/notification-1.mp3'
import successSfx from '../audio/notifications/notification-2.mp3'
import infoSfx from '../audio/notifications/notification-3.mp3'
import warningSfx from '../audio/notifications/notification-4.mp3'
import quickReplies from '../json/quick_replies.json'

import * as XLSX from 'xlsx'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

const axios2 = axios.create();
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const tinyMCEAPIKeys = [
	process.env.VUE_APP_TINY_MCE_API_KEY_1,
	process.env.VUE_APP_TINY_MCE_API_KEY_2,
	process.env.VUE_APP_TINY_MCE_API_KEY_3,
	process.env.VUE_APP_TINY_MCE_API_KEY_4,
	process.env.VUE_APP_TINY_MCE_API_KEY_5,
	process.env.VUE_APP_TINY_MCE_API_KEY_6,
	process.env.VUE_APP_TINY_MCE_API_KEY_7,
	process.env.VUE_APP_TINY_MCE_API_KEY_8,
	process.env.VUE_APP_TINY_MCE_API_KEY_9,
	process.env.VUE_APP_TINY_MCE_API_KEY_10
]
  
const getTinyMCEAccount = () => {
	const today = new Date().getDate();
	const accountIndex = Math.floor((today - 1) / 3) % tinyMCEAPIKeys.length;
	return tinyMCEAPIKeys[accountIndex];
};

Vue.prototype.$internalMode = process.env.VUE_APP_INTERNAL_MODE === 'true' || false
Vue.prototype.$enableChats = process.env.VUE_APP_ENABLE_CHATS === 'true' || false
Vue.prototype.$apiEndpoint = process.env.VUE_APP_BACKEND_ENDPOINT
Vue.prototype.$bxiBackEndpoint = process.env.VUE_APP_BXI_BACKEND_ENDPOINT
Vue.prototype.$bxiFrontEndpoint = process.env.VUE_APP_BXI_FRONTEND_ENDPOINT
Vue.prototype.$bxiAdminAccount = process.env.VUE_APP_BXI_BACKEND_ADMIN_ACCOUNT
Vue.prototype.$bxiAdminUsername = process.env.VUE_APP_BXI_BACKEND_ADMIN_USERNAME
Vue.prototype.$bxiAdminPassword = process.env.VUE_APP_BXI_BACKEND_ADMIN_PASSWORD
Vue.prototype.$itsAdminUsername = process.env.VUE_APP_ITS_BACKEND_ADMIN_USERNAME
Vue.prototype.$itsAdminPassword = process.env.VUE_APP_ITS_BACKEND_ADMIN_PASSWORD
Vue.prototype.$gitEndpoint = process.env.VUE_APP_GIT_ENDPOINT
Vue.prototype.$gitToken = process.env.VUE_APP_GIT_TOKEN
Vue.prototype.$erpEndpoint = process.env.VUE_APP_ERP_ENDPOINT
Vue.prototype.$erpUsername = process.env.VUE_APP_ERP_USERNAME
Vue.prototype.$erpPassword = process.env.VUE_APP_ERP_PASSWORD
Vue.prototype.$tinyMCEAPIKey = getTinyMCEAccount() || process.env.VUE_APP_TINY_MCE_API_KEY
Vue.prototype.$intercomEndpoint = process.env.VUE_APP_INTERCOM_ENDPOINT
Vue.prototype.$intercomToken = process.env.VUE_APP_INTERCOM_TOKEN
Vue.prototype.$http = axios;
Vue.prototype.$openHttp = axios2;
Vue.prototype.$userData = localStorage.getObject('userData')
Vue.prototype.$hideChatNotifications = false
Vue.prototype.$defaultIrippleLogo = 'https://tools.iripple.com/uploads/-/system/appearance/logo/1/iRipple_logo.png'
Vue.prototype.$onlineClients = []
Vue.prototype.$issueClassifications = []
Vue.prototype.$tagTypes = [
	{ key: 'issueClassification', text: 'Issue Classification / Template', value: 'issueClassification' },
  { key: 'label', text: 'Issue Label', value: 'label' }
]
Vue.prototype.$state = [
	{ key: 'active', text: 'Active', value: true },
  { key: 'inactive', text: 'Inactive', value: false }
]
Vue.prototype.$priorities = [
	{ key: '4', text: 'Low (Noticeable)', value: '4', code: 'Low' },
	{ key: '3', text: 'Moderate (Inconvenient)', value: '3', code: 'Moderate' },
	{ key: '2', text: 'Major (Detrimental)', value: '2', code: 'Major' },
	{ key: '1', text: 'Critical (Emergency)', value: '1', code: 'Critical' }
]
Vue.prototype.$autoClose = [
	{ key: '7', text: 'After 7 days', value: 7, code: 'After 7 days' },
	{ key: '14', text: 'After 14 days', value: 14, code: 'After 14 days' },
	{ key: '28', text: 'After 28 days', value: 28, code: 'After 28 days' }
]
Vue.prototype.$agentPriorities = Vue.prototype.$priorities
Vue.prototype.$statuses = [
  { key: 'pending', text: 'Pending', value: 'pending' },
	{ key: 'acknowledged', text: 'Acknowledged', value: 'acknowledged' },
	{ key: 'waitingForClient', text: 'Waiting for Client', value: 'waitingForClient' },
	{ key: 'inProgress', text: 'In Progress', value: 'inProgress' },
	{ key: 'escalated', text: 'Escalated', value: 'escalated' },
	{ key: 'resolved', text: 'Resolved', value: 'resolved' },
	{ key: 'closed', text: 'Closed', value: 'closed' }
]
Vue.prototype.$segments = [
	{ key: 'nosegment', text: 'No Segment', value: null, remarks: 'No Segment' },
  { key: 'fmcg', text: 'FMCG', value: 'fmcg', remarks: 'Fast-Moving Consumer Goods' },
	{ key: 'bnhi', text: 'B&HI', value: 'bnhi', remarks: 'Boutique & Hardware Industry' },
	{ key: 'fnb', text: 'F&B', value: 'fnb', remarks: 'Food & Beverages Services' },
	{ key: 'bxi', text: 'BXI', value: 'bxi', remarks: 'BXI Description' }
]
Vue.prototype.$defaultDates = [
  moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
  moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
]
Vue.prototype.$insensitiveComparison = function (str0, str1){
  return (str0 ? str0.toUpperCase() : '') === (str1 ? str1.toUpperCase() : '')
}
Vue.prototype.$quickReplies = quickReplies || []
Vue.prototype.$defaultTicketTemplate = function (user){
	if(user.role == 'Customer')
		return `<p style="line-height: 1.6;"><span style="font-size: 11pt;">Good day,</span></p><p style="line-height: 1.6;">&nbsp;</p><p style="line-height: 1.6;"><span style="font-size: 11pt;">&lt; Your message goes here &gt;</span></p><p style="line-height: 1.6;">&nbsp;</p><p style="line-height: 1.6;"><span style="font-size: 11pt;">${user.name},</span></p><p style="line-height: 1.6;"><span style="font-size: 10pt;">ITS ${user.client.name} | ${user.email}</span></p>`
	else
		return `<p style="line-height: 1.6;"><span style="font-size: 11pt;">Good day,</span></p><p style="line-height: 1.6;">&nbsp;</p><p style="line-height: 1.6;"><span style="font-size: 11pt;">&lt; Your message goes here &gt;</span></p><p style="line-height: 1.6;">&nbsp;</p><p style="line-height: 1.6;"><span style="font-size: 11pt;">${user.name},</span></p><p style="line-height: 1.6;"><span style="font-size: 10pt;">${user.role} | ${user.email}</span></p>`
}
Vue.prototype.$getDuration = function (ticket = {}, dateField, baseDateField = 'createdAt') {
	if(dateField && ticket && ticket[dateField]){
		let responseTime = moment(ticket[dateField]).diff(moment(ticket[baseDateField]))
		let duration = moment.duration(responseTime)
		let str = ""
		if (duration.days() > 0)
			str += duration.days() + ' day' + (duration.days() > 1 ? 's ' : ' ')
		if (duration.hours() > 0)
			str += duration.hours() + ' hour' + (duration.hours() > 1 ? 's ' : ' ')
		if (duration.minutes() > 0)
			str += duration.minutes() + ' minute' + (duration.minutes() > 1 ? 's ' : ' ')
		else if (duration.days() <= 0 && duration.hours() <= 0 && duration.minutes() <= 0)
			str += 'a minute'
		return str
	}
	else
		return null
}
Vue.prototype.$validateEmail = function (email){
	var re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	return re.test(email)
}
Vue.prototype.$avatars = [
	"avatarArtboard-1.svg",
	"avatarArtboard-2.svg",
	"avatarArtboard-3.svg",
	"avatarArtboard-4.svg",
	"avatarArtboard-5.svg",
	"avatarArtboard-6.svg",
	"avatarArtboard-7.svg",
	"avatarArtboard-8.svg",
	"avatarArtboard-9.svg"
]
Vue.prototype.$generateColors = function(length){
	var colors = ['#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68','#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68','#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68', '#3498db', '#2ecc71', '#f1c40f', '#f39c12', '#4b6584', '#7f8c8d', '#433b68']
	return colors.splice(0, length)
}
Vue.prototype.$distributeSubSet = function(array, number){
	var step = (array.length - 1) / (number - 1)
  var subset = []
  for (var i = 0; i < number; i++){
    subset.push(array[Math.round(step * i)])
	}
	return subset
}
Vue.prototype.$buildTotalsChartData = function(records, multiple, frequency = 50){
	var data = {}
	if(multiple){
	this.$console(records)
	this.$console(records.filter(r => r.record.label == 'Acknowledged'))
		var labels = [...new Set(records.map(r => r.record.label))]
		var names = [...new Set(records.map(r => r.record.name))].sort()
		console.log(names)
		if(names.length > frequency)
			names = this.$distributeSubSet(names, frequency)
		console.log(names)
		var statusColors = {
			'Acknowledged': '#3498dbb3',
			'Resolved': '#2ecc71b3',
			'In Progress': '#f1c40fb3',
			'Pending': '#f39c12b3',
			'Escalated': '#4b6584b3',
			'Closed': '#7f8c8db3',
			'Total Count': '#0b5ed7',
			'Waiting for Client': '#FAD6B1'
		}
		data = {
			labels: names,
			datasets: labels.map((label, i) => {
				return {
					label: label,
					lineTension: 0,
					fill: true,
					borderColor: statusColors[label] || this.$generateColors(labels.length)[i],
					backgroundColor: statusColors[label] || this.$generateColors(labels.length)[i],
					data: names.map(name => {
						var date = records.find(r => r.record.label == label && r.record.name == name) || {}
						return date.total || 0
					})
				}
			})
		}
	}
	else
		data = {
			labels: records.map(r => r.record.name),
			datasets: [
				{
					backgroundColor: this.$generateColors(records.length),
					data: records.map(r => r.total)
				}
			]
		}
	return data
}
Vue.prototype.$getRole = function(role) {
  switch(role){
    case 'Customer':
      return 'customers'
    case 'Agent':
      return 'agents'
    case 'Manager':
      return 'managers'
    case 'Admin':
      return 'admin'
  }
}
Vue.prototype.$statusTitle = {
  pending: 'Pending',
  acknowledged: 'Acknowledged',
  inProgress: 'In Progress',
  escalated: 'Escalated',
  resolved: 'Resolved',
  closed: 'Closed',
  waitingForClient: 'Waiting for Client'
}
Vue.prototype.$alertify = async function(notification) {
	try{
		notification.type = this.$userData.user.disableSFX ? "muted" : notification.type
	}
	catch(e){ e }
	let audio
  Vue.notify(notification)
  switch(notification.type){
    case 'info':
      audio = new Audio(infoSfx)
			audio.volume = 0.2
			audio.play()
      break;
    case 'warning':
      audio = new Audio(warningSfx)
			audio.volume = 0.2
			audio.play()
      break;
    case 'success':
      audio = new Audio(successSfx)
			audio.volume = 0.2
			audio.play()
      break;
		case 'muted':
			break;
    default:
      audio = new Audio(defaultSfx)
			audio.volume = 0.2
			audio.play()
      break;
  }
}
Vue.prototype.$openFile = function(attachment) {
  this.$http.post(
    `${this.$apiEndpoint}/attachment`,
    attachment,
    {
      headers: {
        'Authorization': this.$userData.authToken,
        'Access-Control-Allow-Origin' : '*',
      },
      responseType: "blob"
    }
  ).then((response) => {
      let blob = new Blob([response.data], { type: attachment.mimetype })
      let downloadUrl = window.URL.createObjectURL(blob)
      let a = document.createElement("a");
      this.$alertify({
        group: 'notification',
        title: 'File attachment',
        type: 'success',
        text: 'File download with start in a while.'
      })
      setTimeout(function(){
          if (typeof a.download === "undefined") {
              window.location.href = downloadUrl;
          } else {
              a.href = downloadUrl;
              a.download = attachment.filename;
              document.body.appendChild(a);
              a.click();
          }
      }, 2000)
  }).catch(() => {
      this.$alertify({
        group: 'notification',
        title: 'File attachment',
        type: 'error',
        text: `File does't exist on the server. Contact your administrator for more information.`
      })
  })
}
Vue.prototype.$uploadFiles = async function(attachments) {
  let requests = []
  for(let i = 0; i < attachments.length; i++){
    const request = await this.$http.post(`${this.$apiEndpoint}/attachments`, attachments[i], {
      headers: {
        'Authorization': this.$userData.authToken,
        'Content-Type': attachments[i].mimetype,
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': '*',
        'Access-Control-Allow-Headers': '*'
      }
    })
    requests.push(request)
  }
  const response = await Promise.all(requests)
  return response
}

Vue.prototype.$sleep = function(ms) {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

Vue.prototype.$console = function(obj) {
  if(typeof(obj) === 'object') console.log(JSON.parse(JSON.stringify(obj)))
  else console.log(obj)
}

Vue.prototype.$stripHtml = function(html){
  if(!html) return ''
   let tmp = document.createElement("DIV");
   tmp.innerHTML = html;
   return tmp.textContent || tmp.innerText || "";
}

Vue.prototype.$getTag = function(code){
  return this.$issueClassifications.filter(r => r.record.code === code)[0]
}

Vue.prototype.$getTagDetails = function(issueClassification, key){
  return issueClassification && issueClassification.record && issueClassification.record[key] ? issueClassification.record[key] : []
}

Vue.prototype.$buildOptions = function(options){
  return options.map(r => {
    return { key: r.trim(), text: r.trim(), value: r.trim() }
  })
}

Vue.prototype.$markDownImages = async function(description, gitlab) {
  let matches = regexParser(description, /(<img src="data:image\/[^;]+;base64[^"]+">)/g)
  if(matches) {
    for(let i = 0; i < matches.length; i++){
      let match = matches[i]
      let contentType = regexParser(match, /data:(image\/[^;]+)/)[1]
      let b64Data = match.replace(/<img src="data:image\/[^;]+;base64,/, "").replace("\">","")
      if(contentType && b64Data){
        let file = b64toBlob(b64Data, contentType, 512)
        let response = await this.$uploadImage(file, gitlab)
        if(response && response.data)
          description = description.replace(match, `!${response.data.markdown}`)
        else
          description = description.replace(match, `![[image upload failed]](/)`)
      }
    }
    return description
  }
  else
    return description
}

Vue.prototype.$requestBXIToken = async function(){
	try {
		const response = await this.$http.post(
			`${this.$bxiBackEndpoint}/oauth/token`,
			{
				grant_type: "password",
				account_name: this.$bxiAdminAccount,
				email: this.$bxiAdminUsername,
				password: this.$bxiAdminPassword
			},
			{}
		)
		if(response && response.data && response.data.access_token)
			return response.data.access_token
		else
			return null
	} catch (error) {
		console.log(error)
		return null
	}
}

Vue.prototype.$uploadImage = async function(file, gitlab) {
    const formData = new FormData()
    formData.append('file', file)

    return await this.$http.post(`${this.$gitEndpoint}/projects/${gitlab.id}/uploads`, formData, {
      headers: {
        'Authorization': `Bearer ${this.$gitToken}`,
        'Content-Type': 'multipart/form-data',
        'Access-Control-Allow-Origin' : '*',
      }
    })
    .then((response) => {
        return response
    })
    .catch((error) => {
        return error
    })
}

Vue.prototype.$downloadFile = function(ext, response, filename, format = "legal") {
	let blob, link, url, sheet, workbook
	this.$alertify({
		group: 'notification',
		title: 'Reports Module',
		type: 'success',
		text: 'File will be available in a few seconds.'
	})
	switch(ext){
		default:
		case 'csv':
			blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });
			setTimeout(() => {
				if (navigator.msSaveBlob) {
					navigator.msSaveBlob(blob, `${filename}.csv`);
				} else {
					link = document.createElement("a");
					if (link.download !== undefined) {
						url = URL.createObjectURL(blob);
						link.setAttribute("href", url);
						link.setAttribute("download", `${filename}.csv`);
						link.style.visibility = 'hidden';
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
					}
				}
			}, 1500)
			break;
		case 'pdf':
			blob = new jsPDF({
				orientation: 'landscape',
				format: format
			})
			blob.setFontSize(16);
			blob.text('iRipple Ticketing System', 14, 12)
			blob.setFontSize(10);
			if(response.startsAt && response.endsAt)
				blob.text(`Inclusive dates: ${response.startsAt} - ${response.endsAt}`, 14, 17)
			blob.setFontSize(8);
			blob.autoTable({ html: '#my-table' })
			blob.autoTable({
				head: [response.fields],
				body: response.records,
				theme: 'grid'
			})
			setTimeout(() => {
				blob.save(`${filename}.pdf`)
			}, 1500)
			break
		case 'xslx':
			sheet = XLSX.utils.aoa_to_sheet([response.fields]);
			XLSX.utils.sheet_add_json(sheet, response.records, { skipHeader: true, origin: 'A2' });

			workbook = XLSX.utils.book_new();
			if(response.startsAt && response.endsAt)
				XLSX.utils.book_append_sheet(workbook, sheet, `${response.startsAt} - ${response.endsAt}`);
			else
				XLSX.utils.book_append_sheet(workbook, sheet, `Customers`);
			setTimeout(() => {
				XLSX.writeFile(workbook, `${filename}.xlsx`);
			}, 1500)
			break
	}
}

Vue.prototype.$csvToArray = function (strData){
	return strData.split(',').reduce((accum,curr)=>{
    if(accum.isConcatting) {
      accum.soFar[accum.soFar.length-1] += ','+curr
    } else {
      accum.soFar.push(curr)
    }
    if(curr.split('"').length % 2 == 0) {
      accum.isConcatting = !accum.isConcatting
    }
		return accum;
  },{soFar:[],isConcatting:false}).soFar.map(accum => {
		return (accum && accum[0] === '"' && accum[accum.length-1] === '"') ? accum.slice(1,-1) : accum || "";
	})
}

Vue.prototype.$isOnline = function(user, onlineClients){
	return onlineClients.filter(r => r.user_id === user._id).length > 0
}

export const regexParser = (string, expression) => {
  return string.match(expression);
}

export const b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
}
Vue.prototype.$itsAdminToken = async function(){
	try {
		const response = await this.$http.post(
			`${this.$apiEndpoint}/user/login`,
			{
				email: this.$itsAdminUsername,
				password: this.$itsAdminPassword
			}
		)
		if(response && response.data && response.data.token)
			return response.data.token
		else
			return null
	} catch (error) {
		console.log(error)
		return null
	}
}
Vue.prototype.$checkSession = function(checkTimeRemaining = false){
	var userData = localStorage.getObject('userData')
	const login_timestamp = userData && userData.login_timestamp ? new Date(userData.login_timestamp) : false
	const current_date = new Date()
	const time_diff = 60 * 60 * 1000 * 2 // 2hrs
	const time_prompt = 60 * 5 * 1000 // 5mins
	if(checkTimeRemaining)
		return (time_diff - (current_date - login_timestamp)) <= time_prompt
	else
		return !(login_timestamp && (current_date - login_timestamp) > time_diff)
}
